export const API_URL =
	process.env.REACT_APP_API_URL ||
	"https://e-learningio-backend.vercel.app/api";
export const DEFAULT_IMAGE_URL = "/images/default.png";
export const BASE_UPLOADS =
	"https://e-learningio-backend.vercel.app/api/uploads";
export const BASE_URL = "https://e-learningio.vercel.app/";
